var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66671 0.666667V2H3.33337V0.666667C3.33337 0.489856 3.40361 0.320286 3.52864 0.195262C3.65366 0.0702379 3.82323 0 4.00004 0C4.17685 0 4.34642 0.0702379 4.47145 0.195262C4.59647 0.320286 4.66671 0.489856 4.66671 0.666667Z",
    fill: "#101010"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 0.666667V2H11.3334V0.666667C11.3334 0.489856 11.4036 0.320286 11.5286 0.195262C11.6537 0.0702379 11.8232 0 12 0C12.1769 0 12.3464 0.0702379 12.4714 0.195262C12.5965 0.320286 12.6667 0.489856 12.6667 0.666667Z",
    fill: "#101010"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 7.3335H5.33329V9.3335H2.66663V7.3335Z",
    fill: "#101010"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33329 7.3335H6.66663V9.3335H9.33329V7.3335Z",
    fill: "#101010"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66663 10.6665H5.33329V12.6665H2.66663V10.6665Z",
    fill: "#101010"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33329 10.6665H6.66663V12.6665H9.33329V10.6665Z",
    fill: "#101010"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 7.3335H13.3333V9.3335H10.6666V7.3335Z",
    fill: "#101010"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 15.3332H2C1.46957 15.3332 0.960859 15.1225 0.585786 14.7474C0.210714 14.3723 0 13.8636 0 13.3332V4.6665C0 4.13607 0.210714 3.62736 0.585786 3.25229C0.960859 2.87722 1.46957 2.6665 2 2.6665H14C14.5304 2.6665 15.0391 2.87722 15.4142 3.25229C15.7893 3.62736 16 4.13607 16 4.6665V13.3332C16 13.8636 15.7893 14.3723 15.4142 14.7474C15.0391 15.1225 14.5304 15.3332 14 15.3332ZM14.6667 5.99984H1.33333V13.3332C1.33333 13.51 1.40357 13.6796 1.5286 13.8046C1.65362 13.9296 1.82319 13.9998 2 13.9998H14C14.1768 13.9998 14.3464 13.9296 14.4714 13.8046C14.5964 13.6796 14.6667 13.51 14.6667 13.3332V5.99984Z",
    fill: "#101010"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.bdd96bcadf4b2a0298d6df2befff95a1.svg";
export { ForwardRef as ReactComponent };